import api from '@/services/api'

export default {
    fetchPayments(params) {
        return api.get(`payments/`, {params})
            .then(response => response.data)
    },
    getPayment(params) {
        return api.get(`payments/${params.id}/`, {params})
            .then(response => response.data)
    },
    getCountPayment(params) {
        return api.get(`payments/count/`, {params})
            .then(response => response.data)
    },
    postPayment(payment) {
        return api.postForm(`payments/`, payment)
            .then(response => response.data)
    },
    editPayment(payment) {
        let fd = new FormData()
        for (let key in payment) {
            if (payment[key] === null||key==='client_info') continue;
            fd.append(key, payment[key]);
        }
        return api.putForm(`payments/${payment.id}/`, fd)
            .then(response => response.data)
    }
}